import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const BoxWrapper: CSSObject = {
  px: ['2', '3'],
};

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  boxShadow: 'none',
  border: 0,
  mb: '2',
  bg: 'none',

  _expanded: {
    boxShadow: 'none',
  },

  ...(isNested && {
    boxShadow: 'none',

    _last: { mb: 0 },
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  py: '2',
  bg: 'alpha.100',
  borderBottomRadius: 'base',
  px: '2',
  ...(isNested && {
    borderColor: 'alpha.700',
    border: '1px',
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'alpha.800',
  color: 'white',
  px: '2',
  py: '2.5',
  border: 'none',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 'base',
  fontWeight: 'bold',
  fontSize: 'sm',

  _hover: {
    bg: 'alpha.900',
  },

  '.chakra-accordion__icon': {
    boxSize: ['4', '5'],
    border: '2px',
    borderColor: 'white',
    borderRadius: 'full',
    color: 'white',
    transition: '.3s ease-in-out',
  },

  _expanded: {
    p: '2',
    '.chakra-accordion__icon': {
      boxSize: ['4', '5'],
      borderColor: 'white',
      color: 'white',
      transition: '.3s ease-in-out',
    },
  },

  ...(isNested && {
    _expanded: {
      bg: 'alpha.800',
      borderBottomRadius: 0,
      px: '2',
    },
  }),
});
